import { createFileRoute } from "@tanstack/react-router";
import { PasswordScreen } from "@/components/auth/password-screen";
export const Route = createFileRoute("/auth/reset-password")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { token?: string; error?: string } => ({
    token: typeof search.token === "string" ? search.token : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  component: () => {
    const { token, error } = Route.useSearch();
    return <PasswordScreen reset token={token} invalid={Boolean(error)} />;
  },
});
